import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import AuthService from './AuthService';
import config from '../config';
import apiTargets from 'src/config/apiTargets';
import router from 'src/routes/router';
Vue.use(VueRouter);
let app = new Vue({router});
const { API_HOST, API_VERSION } = config;
axios.defaults.baseURL = `${API_HOST}/api/${apiTargets.ADMIN}/${API_VERSION}`;
export const statusCodesToHandle = [400, 401];

export function successInterceptor(response) {
  return response.data;
}

export async function errorInterceptor(error) {
  // Handle global server error here
  const { status, request } = error.response;
  let errors = '';
  if (statusCodesToHandle.includes(status)) {
    errors = mapErrors(error.response.data);
    if(app.$notifications.state.length === 0) {
      app.$notify({ type: 'danger', message: errors, once: true });
    }
  }
  error.errors = errors;
  if(status === 401 && app.$route.matched.some(record => record.meta.requiresAuth)) {
    AuthService.logout();
    app.$router.push({name: 'login'});
    return Promise.reject(error);
  }
  return Promise.reject(error);
}

export function requestInterceptor(config) {
  let token = AuthService.getToken();
  if (!config.headers['Authorization'] && token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  const appLocale = localStorage.getItem('app_locale') || 'nl'
  if (!config.headers.locale) {
    config.headers.locale = appLocale
  }
  if (typeof config.headers.locale === 'object') {
    config.headers.locale = 'nl' // may happen after logout or after local storage is cleared
  }
  return config;
}
function mapErrors(data) {
  let errors = '';
  if(Array.isArray(data.errors)) {
    return data.errors.join('</br>');
  }
  for (let err in data.errors) {
    let errorRow = data.errors[err].join('</br>');
    if (!errorRow.endsWith('</br>')) {
      errorRow += '</br>';
    }
    errors += errorRow;
  }
  return errors;
}

axios.interceptors.response.use(successInterceptor, errorInterceptor);
axios.interceptors.request.use(requestInterceptor);

export function setLocaleHeader(newLocale) {
  axios.defaults.headers.locale = newLocale
}
